<script setup lang="ts">
import { ref } from 'vue'

const emit = defineEmits(['resend', 'use-different-email'])

defineProps<{
  isCodeLogin: boolean
}>()

const resending = ref(false)

const handleResend = () => {
  resending.value = true
  setTimeout(() => {
    resending.value = false
  }, 1000)
  emit('resend')
}

const handleDifferentEmail = () => {
  emit('use-different-email')
}
</script>

<template>
  <div class="mt-5 d-flex flex-column align-items-center">
    <button
      id="resend"
      class="btn btn-secondary mb-3 btn-sm"
      :disabled="resending"
      @click.prevent="handleResend"
    >
      <transition name="fast-fade" mode="out-in" appear>
        <div v-if="resending" class="align-items-center d-flex">
          <span
            class="spinner-border spinner-border-sm me-2"
            aria-hidden="true"
          ></span>
          <div class="me-2">
            {{ $t('Login.ResendCodeOrLink.Button.ActiveText') }}
          </div>
        </div>
        <span v-else>
          {{
            $t(
              isCodeLogin
                ? 'Login.ResendCodeOrLink.Button.ResendCode'
                : 'Login.ResendCodeOrLink.Button.ResendLink'
            )
          }}
        </span>
      </transition>
    </button>

    <button
      id="diffEmail"
      class="btn btn-link"
      @click.prevent="handleDifferentEmail"
    >
      {{ $t('Login.EmailSent.ChangeEmail') }}
    </button>

    <p class="small my-3">
      {{ $t('Login.EmailSent.JunkNotice') }}
    </p>
  </div>
</template>
